import { AzureMapsProvider } from 'react-azure-maps';

import { PlanningEntityMap } from '../types';

import { Box, Chip } from '@mui/material';

import { useEffect } from 'react';
import { useSessionStorage } from 'usehooks-ts';
import DaypartFilter from '../components/DaypartFilter/DaypartFilter';

import MapController from './MapController';
import { MAPVIEW_SESSION_STORAGE_KEYS } from './types';

interface Props {
  planningEntities: PlanningEntityMap | null;
}
export default function MapView({ planningEntities }: Props) {
  const [{ scheduleId, start }, setFilteredSchedule] = useSessionStorage<{
    scheduleId: string;
    start: string;
  }>(MAPVIEW_SESSION_STORAGE_KEYS.FILTERED_SCHEDULE, {
    scheduleId: '',
    start: ''
  });
  const routeName = Object.values(planningEntities || {})
    .flatMap(({ schedules }) => schedules)
    .find(
      ({ appointmentGrouping }) => appointmentGrouping?.entityId === scheduleId
    )?.name;

  useEffect(() => {
    const set = () => setFilteredSchedule({ start: '', scheduleId: '' });

    // Clean filtered route from session upon hard reload
    window.addEventListener('beforeunload', set);
    // Clean filtered route from session when MapView unmounts and clear listeners
    return () => {
      set();
      window.removeEventListener('beforeunload', set);
    };
  }, []);

  return (
    <>
      <Box display="flex" gap={1} p={2}>
        <DaypartFilter />
        {routeName && scheduleId && (
          <Chip
            label={routeName}
            color="primary"
            size="small"
            variant={'filled'}
            onDelete={() => setFilteredSchedule({ start: '', scheduleId: '' })}
          />
        )}
      </Box>
      <AzureMapsProvider>
        <MapController
          planningEntities={planningEntities}
          scheduleId={scheduleId}
          start={start}
        />
      </AzureMapsProvider>
    </>
  );
}
